import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseCustomControl } from '../baseCustomControl';
import { ControlValueAccessor } from '@angular/forms';
import { iValidatedControl } from '../iValidatedControl';
import { HostBinding } from '@angular/core';
import { FormValidation } from '../../form-validation';
import { ChangeDetectorRef } from '@angular/core';
import { UIHelpers } from '../../ui-helpers';
import { IconType } from '../../../../../../../../libs/Shared/components/icon/icon';

export enum TextModes {
  Text = "Text",
  AlphaNumeric = "AlphaNumeric",
  Numeric = "Numeric",
  Email = "Email",
  Phone = "Phone",
  Date = "Date",
  CurrencyUSD = "USD",
  PostalCodeUS = "PostalUS",
  PostalCodeCAN = "PostalCA",
  Password = "Password",
  Percent = "Percent",
  TaxId = "TaxId",
  TokenVault = "TokenVault",
  MCC = "MCC",
  CommodityCode = 'CommodityCode',
  Website = 'Website',
  FiservTerminalId = 'FiservTerminalId',
}

@Component({
  selector: 'app-textbox',
  imports: [FormsModule],
  templateUrl: './textbox.html',
  styles: ``,
})
export class TextInputComponent extends BaseCustomControl implements ControlValueAccessor, iValidatedControl {

  @HostBinding('class.formField') formFieldClass = true; // Always applied
  @HostBinding('class.readOnly') get isReadOnly() {
    return this.readonly;
  }
  @HostBinding('class.phoneNumberInput') get isPhoneNumber() {
    return this.type == TextModes.Phone;
  }
  @HostBinding('class.currencyInput') get isCurrency() {
    return this.type == TextModes.CurrencyUSD;
  }
  @HostBinding('class.postalCodeInput') get isPostalCode() {
    return this.type == TextModes.PostalCodeUS || this.type == TextModes.PostalCodeCAN;
  }


  // UI:
  @Input() ccCode:string = "US";  // todo: improve this
  @Input() type:TextModes = TextModes.Text;
  @Input() validationLocation:string = "right"; // right | under

  // Options:
  @Input() guidedFormat:string = "";  // if this is specified, then guided format logic is activated
  @Input() minLength:number | undefined;
  @Input() maxLength:number | undefined;
  @Input() minNumericValue:number | undefined;
  @Input() maxNumericValue:number | undefined;
  @Input() regex:string = "";
  @Input() testId:string = "";
  @Input() showDefaultValue:boolean = true;
  @Input() showRequired:boolean = false;
  @Input() defaultText:string | undefined;
  @Input() L2L3Required:boolean = false;

  dateDivider = "";
  patternRegEx:RegExp | undefined;
  TextModes = TextModes;
  IconType = IconType;

  constructor(
    private formValidation:FormValidation,
    changeDetectorRef: ChangeDetectorRef
  ) {
    super(changeDetectorRef);

    /* Is this specific to textbox, still needed, or needed for all controls?
    let nativeId = this.elementRef.nativeElement.id;
    if (nativeId.trim() == "") {
      this.myId = "tb" + Math.random().toString().replace("0.", "");
    }
    else {
      this.myId = nativeId + "_component";
    }
      */

    this.validationMsg = "Invalid";
    this.isValid = false;
  }


  override onValueBound() {
    if (this.type == TextModes.CurrencyUSD && this.boundValue) {
      this.boundValue = UIHelpers.formatCurrency(this.boundValue).replace("$", "").trim();
    } else if (this.boundValue) {
      //this.boundValueFormatted = this.boundValue;
    }
    else {
      super.onValueBound();
    }
  }
  

  override ngOnInit() {

    super.ngOnInit();

    if (this.type == TextModes.Numeric) {
      let validationPattern = "[0-9]";

      let minMaxString:string = "*";

      if (this.minLength) {
        minMaxString = "{" + this.minLength.toString() + ",";
      }
      if (this.maxLength) {
        if (!this.minLength) {
          minMaxString += "{, ";
        }
        minMaxString += this.maxLength + "}";
      }
      else if (this.minLength) {
        minMaxString += "}";
      }
      
      this.patternRegEx = new RegExp(validationPattern + minMaxString);
      this.illegalCharsRegEx = new RegExp(/[^0-9]/g);
    }
    else if (this.type == TextModes.TaxId) {
      this.patternRegEx = new RegExp(/^[0-9]{2}\-[0-9]{7}$/);
      this.illegalCharsRegEx = new RegExp(/[^0-9\-]/g);
    }
    else if (this.type == TextModes.TokenVault) {
      this.patternRegEx = new RegExp(/^[A-Z]{1,13}$/);
    }
    else if (this.type == TextModes.MCC) {
      this.patternRegEx = new RegExp(/^[0-9]{4}$/);
    }
    else if (this.type == TextModes.CommodityCode) {
      this.patternRegEx = new RegExp(/^[0-9]{8,10}$/);
    }
    else if (this.type == TextModes.AlphaNumeric) {
      let validationPattern = "[a-zA-Z0-9]";

      if (this.maxLength) {
        validationPattern += "{" + this.maxLength + "}";
      }
      
      this.patternRegEx = new RegExp("/" + validationPattern + "/");
      this.illegalCharsRegEx = new RegExp(/[^a-zA-Z0-9]/g);
    }
    else if (this.type == TextModes.Email) {
      this.patternRegEx = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
      this.illegalCharsRegEx = new RegExp(/[^a-zA-Z0-9._%+-@]/g);
      this.control_width_pct = "100";
    }
    else if (this.type == TextModes.Phone) {
      this.patternRegEx = new RegExp(/^[\(]?\d{3}[\)]?(\.|-)?[\(]?\d{3}[\)]?(\.|-)?[\(]?\d{4}[\)]?$/); // does not include country code right now
      this.illegalCharsRegEx = new RegExp(/[^0-9\.\-]/g);
      this.control_width_pct = "100";
      this.guidedFormat = "xxx-xxx-xxxx";

      if (!this.hint) {
        this.hint = this.guidedFormat;
      }
    }
    else if (this.type == TextModes.Website) {
      this.patternRegEx = new RegExp(/^(https?:\/\/)[^\s/$.?#].[^\s]*\.[^\s]+[^\s]*$/i);
      this.guidedFormat = "https://www.example.com";
      if (!this.hint) {
        this.hint = this.guidedFormat;
      }
    }
    else if (this.type == TextModes.FiservTerminalId) {
      this.patternRegEx = new RegExp(/^[0-9]{7}$/);
    }
    else if (this.type == TextModes.Password) {
      this.control_width_pct = "100";
    }
    else if (this.type == TextModes.CurrencyUSD) {
      this.patternRegEx = new RegExp(/^[$]?\d+(?:(\.|,)\d{1,2})?$/);
      this.illegalCharsRegEx = new RegExp(/[^0-9\.\,]/g);
      this.control_width_pct = "100";

      if (!this.hint) {
        this.hint = "xx.xx";
      }
    }
    else if (this.type == TextModes.Date) {
      if (this.guidedFormat == "") {
        this.guidedFormat = "mm/dd/yyyy";
      }

      this.dateDivider = this.guidedFormat.replaceAll(new RegExp(/[mdy]/g), "")[0];

      // MM/DD/YYYY
      if (new RegExp(/^m{2}[\/-]?d{2}[\/-]?y{4}$/).test(this.guidedFormat)){
        this.patternRegEx = new RegExp("^\\d{2}\\" + this.dateDivider + "\\d{2}\\" + this.dateDivider + "\\d{4}$");
      }
      // DD/MM/YYYY
      else if (new RegExp(/^d{2}[\/-]?m{2}[\/-]?y{4}$/).test(this.guidedFormat)){
        this.patternRegEx = new RegExp("^\\d{2}\\" + this.dateDivider + "\\d{2}\\" + this.dateDivider + "\\d{4}$");
      }
      // YYYY/MM/DD
      else if (new RegExp(/^y4{2}[\/-]?m{2}[\/-]?d{2}$/).test(this.guidedFormat)){
        this.patternRegEx = new RegExp("^\\d{4}\\" + this.dateDivider + "\\d{2}\\" + this.dateDivider + "\\d{2}$");
      }
      else {
        throw "unsupported date format";
      }

      this.illegalCharsRegEx = new RegExp(/[^0-9\/-]/g)

      if (!this.hint) {
        this.hint = this.guidedFormat;
      }
    }
    else if (this.type == TextModes.PostalCodeUS) {
      this.patternRegEx = new RegExp(/^[0-9]{5}(\-{1}[0-9]{4})?$/);
      this.illegalCharsRegEx = new RegExp(/[^0-9\-]/g)
    }
    else if (this.type == TextModes.PostalCodeCAN) {
      this.patternRegEx = new RegExp(/^[0-9a-fA-F]{6}?$/);
      this.illegalCharsRegEx = new RegExp(/[^0-9a-fA-F]/g)
    }

    if (this.regex != "") {
      this.patternRegEx = new RegExp(this.regex);
    }
  }

  ngAfterViewInit() {
    if (this.inputControl && this.inputControl.nativeElement.getAttribute('placeholder')) {
      let minLength = this.inputControl.nativeElement.getAttribute('placeholder')?.length;

      if (minLength)
        this.inputControl.nativeElement.setAttribute('size', (minLength + 20) + "px");
    }

    // TODO:This causes issues with change detection. If the only point of calling 
    // validation here is to force visibility of the required tags, then we
    // should do something different.
    
    // if (this.showRequired) {
    //   this.validate();
    // }
    
  }

  get value():string {
    if (this.actualValue) {
      return this.actualValue;
    }
    return "";
  }

  formatForReadOnly(text:string) {
    if (this.type == TextModes.Phone) {
      return UIHelpers.formatPhone(text, this.ccCode);
    }
    return text;
  }

  public validate():boolean {

    this.isValid = true;
    this.validationMsg = "";

    if (this.required && this.value == "") {
      this.isValid = false;
      this.validationMsg = "required";
    }
    else if (!this.required && this.value == "") {
      this.isValid = true;
    }
    else if (this.patternRegEx) {
      this.isValid = this.patternRegEx.test(this.value);
    }
    
    if (this.minNumericValue && (this.type == TextModes.Numeric || this.type == TextModes.CurrencyUSD)) {
      this.isValid = this.isValid && parseFloat(this.value) >= this.minNumericValue; 
    }
    if (this.maxNumericValue && (this.type == TextModes.Numeric || this.type == TextModes.CurrencyUSD)) {
      this.isValid = this.isValid && parseFloat(this.value) <= this.maxNumericValue; 
    }

    if (!this.isValid) {
      this._handle_validateFailed();

      if (this.validationMsg == "") {
        this.validationMsg = "invalid"
      }
    }
    else {
      this._handle_validatePassed();
    }

    return this.isValid;
  }


  _handle_onKeyUp(e:KeyboardEvent) {
    // Here, we're only going to test the current key stroke if it's 
    // not a non-character (like backspace or arrow)
    if (new RegExp(/^[0-9a-zA-Z!@#\$%\^&\*()~\`\'\";:,.\/\?\\|~]$/).test(e.key)) {
      if (this.illegalCharsRegEx) {
        this.boundValue = this.boundValue.replaceAll(this.illegalCharsRegEx, "");
        this.boundValue = this.boundValue;
      }
      this.actualValue = this.boundValue;
    }
    
    if (this.guidedFormat != "") {
      if (this.type == TextModes.Phone) {
        if (this.boundValue) {
          this.boundValue = this.boundValue.trim();
          this.boundValue = this.formValidation.formatPhoneInput(e, this.boundValue, this.guidedFormat);
        }
      }
      else if (this.type == TextModes.Date) {
        if (this.boundValue) {
          this.boundValue = this.boundValue.trim();
          this.boundValue = this.formValidation.formatDateInput(e, this.boundValue, this.guidedFormat);
        }
      }
    }
    else if (this.validateOn == "change") {
      // If validation failed before, and the user is deleting or backspacing, 
      // let's clear the message while the user is typing so it doesn't appear that what
      // they're typing still fails validation
      if (this.type == TextModes.CurrencyUSD) {

        // The problem here is that we don't want currency to start with a zero. But that
        // may actually be what the final value should be. We will allow the first zero
        // and format it as currency. Then on subsequent keystrokes, things will progress
        // as intended.
        if (this.boundValue == "0") {
          this.boundValue = "0.00";
          return;
        }

        // we don't know yet if the user is going to type a decimal,
        // so just let them go until we lose focus.
        this.boundValue = this.boundValue?.trim().replace(".", "");
        this.boundValue = this.boundValue?.replace(/^0(\.)?/, '');
        this.actualValue = this.boundValue;
        
        if (!this.boundValue || this.boundValue == "0") {
          this.boundValue = "";
          this.validate();
        }
        else if (this.boundValue) {

            if (this.boundValue.length < 2) {
              this.boundValue = "0.0" + this.boundValue;
            }
            else if (this.boundValue.length < 3) {
              this.boundValue = "0." + this.boundValue;
            }
            else {
              // removes commas and decimal point from the number
             this.boundValue = this.boundValue.replace(".", "").replace(/,/g, "");
             this.boundValue = Number(this.boundValue.slice(0, this.boundValue.length-2) + "." + this.boundValue.slice(this.boundValue.length-2));
            }

          this.isValid = true;
        }

        const formattedBoundValue = UIHelpers.formatCurrency(Number(this.boundValue)).replace('$', '');
        this.boundValue = formattedBoundValue;
        this.actualValue = formattedBoundValue.replace('$', '').replace(',', '');
      }
      else if (this.type == TextModes.Numeric) {
        // if there's a decimal, just look at the whole number part:
        if (this.boundValue.includes(".")) {
          this.boundValue = Number(this.boundValue.split(".")[0]).toLocaleString() + "." + this.boundValue.split(".")[1];
        }
        else {
          this.boundValue = Number(this.boundValue).toLocaleString();
        }
      } else if (this.type == TextModes.TokenVault) {
        if (this.boundValue.startsWith("TEST")) {
          this.boundValue = this.boundValue.replace("TEST", "");
        }
      }
      else {
        this.actualValue = this.boundValue;
      }

      if (e.code != "Backspace" && e.code != "Delete") {
        this.validate();
      }
      else if (!this.isValid) {
        this.validate();
      }

    }
    else {
      // If validation failed before, let's clear the message
      // while the user is typing so it doesn't appear that what
      // they're typing still fails validation
      this.isValid = true;
      this._clearValidationMessage();

      this.actualValue = this.boundValue;
    }

    this.onChange(this.actualValue);

    if (this.onChanged) {
      this.onChanged.emit(this.actualValue);
    }

    return true;
  }

  override handle_onBlur(e:FocusEvent) {
    this.validate();
    this.onChanged.emit(this.actualValue);
  }

}

